import { useAuth } from '@/lib/AuthContext';

export const useSuperAdmin = () => {
  const { user, isLoading, refreshUser } = useAuth();

  return {
    isSuperAdmin: user?.is_super_admin ?? false,
    isLoading,
    error: null,
    checkSuperAdmin: refreshUser,
  };
};
